import { useEffect } from 'react';

/**
 * This hook shows an alert when the user tries to close the browser tab, or navigate to another route
 */
const usePreventTabClose = ({ hasUnsavedChanges }) => {
  useEffect(() => {
    const alertWhenConfirmingCheckout = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();

        // This message is not supported on modern browsers
        const returnValue = 'Changes may not be saved.';
        e.returnValue = returnValue;

        return returnValue;
      }

      return null;
    };

    window.addEventListener('beforeunload', alertWhenConfirmingCheckout);

    return () => {
      window.removeEventListener('beforeunload', alertWhenConfirmingCheckout);
    };
  }, [hasUnsavedChanges]);
};

export default usePreventTabClose;
